import React from "react";
import FullName from "../../tables/FullName";
import Date from "../../tables/Date";
import Phone from "../../tables/Phone";
import Age from "../../tables/Age";
import Gender from "../../tables/Gender";
import Address from "../../tables/Address";
import OpportunityStatus from "../../tables/OpportunityStatus";
import PatientBranch from "../../tables/PatientBranch";
import {
  EditOutlined,
  UserSwitchOutlined,
  DownOutlined,
  InteractionOutlined,
} from "@ant-design/icons";
import { getFullName } from "../../util/helpers";
import { Typography, Tooltip, Button, Select, Dropdown } from "antd";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import moment from "moment";
var flatten = require("flat");
const { Text } = Typography;
const { Option } = Select;

const getColumns = (source, intl, location, dispatch, props) => {
  let patient_opportunity_statuses = [];
  if (
    source === "opportunities" &&
    props &&
    props.patient_opportunity_statuses
  ) {
    patient_opportunity_statuses = props.patient_opportunity_statuses;
  }
  let tableItems = [];
  const branchPath = location.pathname.substring(
    0,
    location.pathname.lastIndexOf("/")
  );

  const filtersArr = [
    {
      value: "opened",
      text: <FormattedMessage id="app.dataSelect.taskType.opened" />,
    },
    {
      value: "inprogress",
      text: <FormattedMessage id="app.dataSelect.taskType.inprogress" />,
    },
    {
      value: "cancelled",
      text: <FormattedMessage id="app.dataSelect.taskType.cancelled" />,
    },
    {
      value: "completed",
      text: <FormattedMessage id="app.dataSelect.taskType.completed" />,
    },
  ];

  const taskData = [
    {
      value: "opened",
      name: <FormattedMessage id="app.dataSelect.taskType.opened" />,
    },
    {
      value: "inprogress",
      name: <FormattedMessage id="app.dataSelect.taskType.inprogress" />,
    },
    {
      value: "cancelled",
      name: <FormattedMessage id="app.dataSelect.taskType.cancelled" />,
    },
    {
      value: "completed",
      name: <FormattedMessage id="app.dataSelect.taskType.completed" />,
    },
  ];

  const leadsStatusData = [
    {
      value: "unqualified",
      name: <FormattedMessage id="app.leads.unqualified" />,
    },
    {
      value: "new",
      name: <FormattedMessage id="app.leads.new" />,
    },
    {
      value: "working",
      name: <FormattedMessage id="app.leads.working" />,
    },
    {
      value: "nurturing",
      name: <FormattedMessage id="app.leads.nurturing" />,
    },
    {
      value: "converted",
      name: <FormattedMessage id="app.leads.converted" />,
    },
  ];

  //         title={intl.formatMessage({
  //           id: "app.opportunities.convert_patient",
  //         })}
  //       >
  //         <Button
  //           type="text"
  //           icon={<UserSwitchOutlined />}
  //           onClick={() => onLaunchEntityModal(record, "edit")}
  //         />
  //       </Tooltip>

  const actionsDropDownMenuItems = [
    {
      label: intl.formatMessage({
        id: "app.opportunities.convert_patient",
      }),
      key: "1",
      icon: <UserSwitchOutlined />,
    },
    {
      label: intl.formatMessage({
        id: "app.patients.transferPatient",
      }),
      key: "2",
      icon: <InteractionOutlined />,
    },
  ];

  const handleOpportunitiesMenuClick = (e, record) => {
    switch (e.key) {
      case "1":
        props.onLaunchCreateOpportunityModal(record, "edit");
        break;

      case "2":
        props.onLaunchChangeBranch(record);
        break;

      default:
        break;
    }
  };

  const getOpportunitiesActionsMenu = (record) => {
    const actionsDropDownMenu = {
      items: actionsDropDownMenuItems,
      onClick: (e) => handleOpportunitiesMenuClick(e, record),
    };
    return actionsDropDownMenu;
  };

  switch (source) {
    case "leads":
      tableItems = [
        {
          title: intl.formatMessage({
            id: "app.leads.fullname",
          }),
          width: "140px",
          render(text, record) {
            return (
              <FullName
                record={record}
                customLocation={`${branchPath}/leads/${record.id}`}
                customUrlParam={record}
              />
            );
          },
        },
        {
          title: intl.formatMessage({
            id: "app.leads.mobile_number",
          }),
          dataIndex: "contact_info",
          responsive: ["md"],
          render(text, record) {
            return <Phone text={text.mobile_number} ellipsis={true} />;
          },
          width: "140px",
          ellipsis: true,
        },
        {
          title: intl.formatMessage({
            id: "app.leads.phone_number",
          }),
          dataIndex: "contact_info",
          responsive: ["xxl"],
          render(text, record) {
            return <Phone text={text.phone_number} ellipsis={true} />;
          },
          width: "140px",
          ellipsis: true,
        },
        {
          title: intl.formatMessage({
            id: "app.leads.age",
          }),
          dataIndex: "birthday",
          responsive: ["lg"],
          render(text, record) {
            return <Age record={record} field={"birthday"} />;
          },
          sortIndex: "birthday",
          sorter: true,
          columnProps: { field: "birthday" },
          width: "70px",
        },
        {
          title: intl.formatMessage({
            id: "app.leads.gender",
          }),
          dataIndex: "gender_id",
          responsive: ["xl"],
          render(text, record) {
            return <Gender text={text} />;
          },
          width: "70px",
          filters: [
            {
              text: <FormattedMessage id="app.dataSelect.gender_id.male" />,
              value: 1,
            },
            {
              text: <FormattedMessage id="app.dataSelect.gender_id.female" />,
              value: 2,
            },
          ],
        },

        // {
        //   title: intl.formatMessage({
        //     id: "app.leads.lead_owner",
        //   }),
        //   dataIndex: "lead_owner",
        //   width: "140px",
        //   render(text, record) {
        //     return <Text>{getFullName(text.surename, text.first_name)}</Text>;
        //   },
        // },
        {
          title: intl.formatMessage({
            id: "app.leads.assigned_to",
          }),
          dataIndex: "assigned_to",
          width: "140px",
          render(text, record) {
            return <Text>{getFullName(text.surename, text.first_name)}</Text>;
          },
        },
        {
          title: intl.formatMessage({
            id: "app.leads.created_at",
          }),
          dataIndex: "created_at",
          width: "120px",
          render(text, record) {
            return <Date text={text} format={"L"} />;
          },
          sortIndex: "created_at",
          sorter: true,
        },

        {
          title: intl.formatMessage({
            id: "app.leads.updated_at",
          }),
          dataIndex: "updated_at",
          width: "120px",
          render(text, record) {
            return <Date text={text} format={"L"} />;
          },
          sortIndex: "updated_at",
          sorter: true,
          columnProps: { format: "L" },
        },

        {
          title: intl.formatMessage({
            id: "app.leads.status",
          }),
          dataIndex: "status",
          filteredValue: null,
          width: "130px",
          filters: filtersArr,
          render(text, record) {
            const color =
              text.name === "new"
                ? "initial"
                : text === "working"
                ? "#faad14"
                : text === "nurturing"
                ? "#FF4D51"
                : "#52c41a";

            return (
              <Select
                // onChange={(val) => onChange(record, val)}
                defaultValue={text.name}
                style={{ color: color, width: "100px" }}
              >
                {leadsStatusData.map((option) => (
                  <Option key={option.value} value={option.value}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            );
          },
        },
        {
          title: intl.formatMessage({
            id: "app.leads.actions",
          }),
          responsive: ["md"],
          width: "100px",
          render(text, record) {
            return (
              <div style={{ display: "flex" }}>
                <Tooltip
                  title={intl.formatMessage({
                    id: "app.tasks.editTask",
                  })}
                >
                  <Button
                    type="text"
                    icon={<EditOutlined />}
                    onClick={() => props.onLaunchEntityModal(record, "edit")}
                  />
                </Tooltip>
              </div>
            );
          },
        },
      ];
      break;

    case "opportunities":
      tableItems = [
        {
          title: intl.formatMessage({
            id: "app.leads.fullname",
          }),
          width: "140px",
          render(text, record) {
            return (
              <FullName
                record={record}
                customLocation={`${branchPath}/crm_patients/${record.id}`}
                customUrlParam={record}
              />
            );
          },
        },
        {
          title: intl.formatMessage({
            id: "app.opportunities.opportunity_status",
          }),
          dataIndex: "opportunity_status_id",
          responsive: ["md"],
          render(text, record) {
            return <OpportunityStatus record={record} />;
          },
          filters: patient_opportunity_statuses.map((i) => {
            return {
              value: i.id,
              text: intl.formatMessage({
                id: `app.opportunities.${i.name}`,
              }),
            };
          }),
          width: "100px",
        },
        {
          title: intl.formatMessage({
            id: "app.leads.mobile_number",
          }),
          dataIndex: "contact_info",
          responsive: ["md"],
          render(text, record) {
            return <Phone text={text.mobile_number} ellipsis={true} />;
          },
          width: "140px",
          ellipsis: true,
        },
        {
          title: intl.formatMessage({
            id: "app.leads.phone_number",
          }),
          dataIndex: "contact_info",
          responsive: ["xxl"],
          render(text, record) {
            return <Phone text={text.phone_number} ellipsis={true} />;
          },
          width: "140px",
          ellipsis: true,
        },
        {
          title: intl.formatMessage({
            id: "app.leads.age",
          }),
          dataIndex: "birthday",
          responsive: ["lg"],
          render(text, record) {
            return <Age record={record} field={"birthday"} />;
          },
          sortIndex: "birthday",
          sorter: true,
          columnProps: { field: "birthday" },
          width: "70px",
        },
        {
          title: intl.formatMessage({
            id: "app.leads.gender",
          }),
          dataIndex: "gender_id",
          responsive: ["xl"],
          render(text, record) {
            return <Gender text={text} />;
          },
          width: "70px",
          filters: [
            {
              text: <FormattedMessage id="app.dataSelect.gender_id.male" />,
              value: 1,
            },
            {
              text: <FormattedMessage id="app.dataSelect.gender_id.female" />,
              value: 2,
            },
          ],
        },

        // {
        //   title: intl.formatMessage({
        //     id: "app.leads.assigned_to",
        //   }),
        //   dataIndex: "assigned_to",
        //   width: "140px",
        //   render(text, record) {
        //     return <Text>{getFullName(text.surename, text.first_name)}</Text>;
        //   },
        // },
        {
          title: intl.formatMessage({
            id: "app.leads.created_at",
          }),
          dataIndex: "created_at",
          width: "120px",
          render(text, record) {
            return <Date text={text} format={"L"} />;
          },
          sortIndex: "created_at",
          sorter: true,
        },

        {
          title: intl.formatMessage({
            id: "app.leads.updated_at",
          }),
          dataIndex: "updated_at",
          width: "120px",
          render(text, record) {
            return <Date text={text} format={"L"} />;
          },
          sortIndex: "updated_at",
          sorter: true,
          columnProps: { format: "L" },
        },
        {
          title: intl.formatMessage({
            id: "app.opportunities.actions",
          }),
          responsive: ["md"],
          width: "100px",
          render(text, record) {
            const menu = getOpportunitiesActionsMenu(record);
            return (
              <div style={{ display: "flex" }}>
                <Dropdown trigger={["click"]} menu={menu}>
                  <Button type="link">
                    {intl.formatMessage({
                      id: "app.opportunities.options",
                    })}
                    <DownOutlined />
                  </Button>
                </Dropdown>
              </div>
            );
          },
        },
      ];
      break;

    case "contacts":
      tableItems = [
        {
          title: intl.formatMessage({
            id: "app.leads.fullname",
          }),
          width: "140px",
          render(text, record) {
            return (
              <FullName
                record={record}
                customLocation={`${branchPath}/contacts/${record.id}`}
                customUrlParam={record}
              />
            );
          },
        },
        {
          title: intl.formatMessage({
            id: "app.leads.mobile_number",
          }),
          dataIndex: "contact_info",
          responsive: ["md"],
          render(text, record) {
            return <Phone text={text.mobile_number} ellipsis={true} />;
          },
          width: "140px",
          ellipsis: true,
        },
        {
          title: intl.formatMessage({
            id: "app.leads.phone_number",
          }),
          dataIndex: "contact_info",
          responsive: ["xxl"],
          render(text, record) {
            return <Phone text={text.phone_number} ellipsis={true} />;
          },
          width: "140px",
          ellipsis: true,
        },
        {
          title: intl.formatMessage({
            id: "app.leads.age",
          }),
          dataIndex: "birthday",
          responsive: ["lg"],
          render(text, record) {
            return <Age record={record} field={"birthday"} />;
          },
          sortIndex: "birthday",
          sorter: true,
          columnProps: { field: "birthday" },
          width: "70px",
        },
        {
          title: intl.formatMessage({
            id: "app.leads.gender",
          }),
          dataIndex: "gender_id",
          responsive: ["xl"],
          render(text, record) {
            return <Gender text={text} />;
          },
          width: "70px",
          filters: [
            {
              text: <FormattedMessage id="app.dataSelect.gender_id.male" />,
              value: 1,
            },
            {
              text: <FormattedMessage id="app.dataSelect.gender_id.female" />,
              value: 2,
            },
          ],
        },
        // {
        //   title: intl.formatMessage({
        //     id: "app.leads.lead_owner",
        //   }),
        //   dataIndex: "lead_owner",
        //   width: "140px",
        //   render(text, record) {
        //     return <Text>{getFullName(text.surename, text.first_name)}</Text>;
        //   },
        // },
        {
          title: intl.formatMessage({
            id: "app.leads.assigned_to",
          }),
          dataIndex: "assigned_to",
          width: "140px",
          render(text, record) {
            return <Text>{getFullName(text.surename, text.first_name)}</Text>;
          },
        },
        {
          title: intl.formatMessage({
            id: "app.leads.created_at",
          }),
          dataIndex: "created_at",
          width: "120px",
          render(text, record) {
            return <Date text={text} format={"L"} />;
          },
          sortIndex: "created_at",
          sorter: true,
        },

        {
          title: intl.formatMessage({
            id: "app.leads.updated_at",
          }),
          dataIndex: "updated_at",
          width: "120px",
          render(text, record) {
            return <Date text={text} format={"L"} />;
          },
          sortIndex: "updated_at",
          sorter: true,
          columnProps: { format: "L" },
        },
        {
          title: intl.formatMessage({
            id: "app.leads.actions",
          }),
          responsive: ["md"],
          width: "100px",
          render(text, record) {
            return (
              <div style={{ display: "flex" }}>
                <Tooltip
                  title={intl.formatMessage({
                    id: "app.tasks.editTask",
                  })}
                >
                  <Button
                    type="text"
                    icon={<EditOutlined />}
                    onClick={() => props.onLaunchEntityModal(record, "edit")}
                  />
                </Tooltip>
              </div>
            );
          },
        },
      ];
      break;

    case "campaigns":
      tableItems = [
        {
          title: intl.formatMessage({
            id: "app.campaigns.name",
          }),
          dataIndex: "name",
          width: "140px",
          render(text, record) {
            return (
              <Link
                style={{ color: "inherit", textDecoration: "underline" }}
                to={{
                  pathname: `${branchPath}/campaigns/${record.id}`,
                  state: record,
                }}
              >
                <div className="content">{text}</div>
              </Link>
            );
          },
        },
        {
          title: intl.formatMessage({
            id: "app.campaigns.start_date",
          }),
          dataIndex: "start_date",
          width: "120px",
          render(text, record) {
            return <Date text={text} format={"L"} />;
          },
          sortIndex: "start_date",
          sorter: true,
        },

        {
          title: intl.formatMessage({
            id: "app.campaigns.end_date",
          }),
          dataIndex: "end_date",
          width: "120px",
          render(text, record) {
            return <Date text={text} format={"L"} />;
          },
          sortIndex: "end_date",
          sorter: true,
        },
        {
          title: intl.formatMessage({
            id: "app.campaigns.campagin_owner",
          }),
          dataIndex: "campagin_owner",
          width: "140px",
          render(text, record) {
            return <Text>{text.name}</Text>;
          },
        },
        {
          title: intl.formatMessage({
            id: "app.campaigns.status",
          }),
          dataIndex: "status",
          width: "140px",
          render(text, record) {
            return <Text>{text.name}</Text>;
          },
        },
        {
          title: intl.formatMessage({
            id: "app.campaigns.type",
          }),
          dataIndex: "type",
          width: "140px",
          render(text, record) {
            return <Text>{text.name}</Text>;
          },
        },
        {
          title: intl.formatMessage({
            id: "app.leads.actions",
          }),
          responsive: ["md"],
          width: "100px",
          render(text, record) {
            return (
              <div style={{ display: "flex" }}>
                <Tooltip
                  title={intl.formatMessage({
                    id: "app.tasks.editTask",
                  })}
                >
                  <Button
                    type="text"
                    icon={<EditOutlined />}
                    onClick={() => props.onLaunchEntityModal(record, "edit")}
                  />
                </Tooltip>
              </div>
            );
          },
        },
      ];
      break;

    case "events_schedule":
      tableItems = [
        {
          title: intl.formatMessage({
            id: "app.events_schedule.subject",
          }),
          dataIndex: "subject",
          width: "140px",
        },
        {
          title: intl.formatMessage({
            id: "app.events_schedule.name",
          }),
          dataIndex: "name",
          render(text, record) {
            return <Text>{getFullName(text.surename, text.first_name)}</Text>;
          },
          width: "140px",
        },
        {
          title: intl.formatMessage({
            id: "app.events_schedule.date",
          }),
          dataIndex: "start_date",
          width: "120px",
          render(text, record) {
            return <Date text={text} format={"L"} />;
          },
          sortIndex: "start_date",
          sorter: true,
        },

        {
          title: intl.formatMessage({
            id: "app.events_schedule.event_hours",
          }),
          dataIndex: "end_date",
          width: "120px",
          render(text, record) {
            return (
              <Text>{`${moment(record.start_date).format("HH:mm")}-${moment(
                record.end_date
              ).format("HH:mm")}`}</Text>
            );
          },
          sortIndex: "end_date",
          sorter: true,
        },
        {
          title: intl.formatMessage({
            id: "app.events_schedule.location",
          }),
          dataIndex: "address",
          render(text, record) {
            return <Address record={flatten(record, { safe: true })} />;
          },
          width: "140px",
        },
        {
          title: intl.formatMessage({
            id: "app.events_schedule.assigned_to",
          }),
          dataIndex: "assigned_to",
          width: "140px",
          render(text, record) {
            return (
              <Link
                style={{ color: "inherit", textDecoration: "underline" }}
                to={{
                  pathname: `${branchPath}/campaigns/${record.id}`,
                  state: record,
                }}
              >
                <div className="content">
                  {getFullName(text.surename, text.first_name)}
                </div>
              </Link>
            );
          },
        },
        {
          title: intl.formatMessage({
            id: "app.events_schedule.related_to",
          }),
          dataIndex: "related_to",
          width: "140px",
          render(text, record) {
            return (
              <Link
                style={{ color: "inherit", textDecoration: "underline" }}
                to={{
                  pathname: `${branchPath}/campaigns/${record.id}`,
                  state: record,
                }}
              >
                <div className="content">
                  {getFullName(text.surename, text.first_name)}
                </div>
              </Link>
            );
          },
        },
      ];
      break;

    default:
      tableItems = [];
      break;
  }

  const isAdmin = location.pathname.includes("admin");
  if (isAdmin && source === "opportunities") {
    tableItems.splice(1, 0, {
      title: intl.formatMessage({
        id: "app.opportunities.branch_id",
      }),
      dataIndex: "branch_id",
      render(text, record) {
        return <PatientBranch record={record} />;
      },
      width: "120px",
      responsive: ["lg"],
      filters: props.userBranches.map((i) => ({ text: i.name, value: i.id })),
    });
  }

  return tableItems;
};

export { getColumns };
